<template>
    <div class="index">
        <!-- <keep-alive :include="['Parking']"> -->
        <router-view />
        <!-- </keep-alive> -->
        <tabbar />
    </div>
</template>
<script>
import Tabbar from "@/components/tabbar/index.vue";
export default {
    name: "Index",
    components: {
        Tabbar,
    },

    data() {
        return {};
    },
    methods: {},
};
</script>
<style scoped lang="less"></style>
